import React, {useState, useEffect} from 'react'
import { Card, Col, Container, Row ,Button, Form, Spinner,Alert} from 'react-bootstrap';
import alumnidata from "./alumni.json";
import seniorsdata from "./seniors.json";
import juniorsdata from "./juniors.json";
// import {Link} from "react-router-dom"
import styles from "./Team.module.css";
import { faLinkedin, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios'
import Picmodal from "./PictureModal";
import { faPaperPlane, faRedoAlt} from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";


function UpdateTeam(props) {
    // console.log(props);
    // const {alumni,seniors,juniors}=props

    const [alumni,setAlumni] = useState(alumnidata)
    const [seniors, setSeniors] = useState(seniorsdata)
    const [juniors, setJuniors] = useState(juniorsdata)
    const [reload, setReload] = useState(true)
    const [option, setOption] = useState(0)
    const [data, setData] = useState({name:"",Linkedin:"",imageURL:"",position:"",year:""})
    const [url, setUrl] = useState(false)
    const [post, setPost] = useState(false)
    const [select, setSelect] = useState("Select")
    const [remove, setRemove] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [photoselect, setPhotoSelect] = useState(false);
    const [teampic, setTeampic] = useState({teamimage:"https://dl.dropboxusercontent.com/s/157843ml9zhnixe/group.jpg?dl=0"})
    const [newPic, setNewPic] = useState({teamimage:""})
    const [pushpic, setPushpic] = useState(false)
    const [spin, setSpin] = useState(false)
    const [spinDelete, setSpinDelete] = useState(false)
    const [resultBar,SetResultBar]=useState(false)
    useEffect(()=>{
        if (reload) {
            axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Alumni?sort=year')
                .then(response=>{
                    console.log(response);
                    setAlumni(response.data.data.alumnis)
                })
                .catch(error=>{
                    console.log(error);
                })
                axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Juniors')
                .then(response=>{
                    setJuniors(response.data.data.juniors)
                })
                .catch(error=>{
                    console.log(error);
                })
                axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Seniors')
                .then(response=>{
                    setSeniors(response.data.data.seniors)
                })
                .catch(error=>{
                    console.log(error);
                })
                axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/teampic')
                .then(response=>{
                    console.log(response);
                    setTeampic(response.data.data.teampic[0])
                })
                .catch(error=>{
                    console.log(error);
                })
            setReload(false)
        }
        if (post) {
            setSpin(<Spinner animation="border" variant="success" />)
            axios.post(url,data)
                .then(response=>{
                    console.log(response);
                    Reset()
                    setReload(true)
                    setSpin(false)
                    SetResultBar(<Alert key={1} variant="success"><h5>Member Successfully Pushed</h5></Alert>)
                })
                .catch(error=>{
                    console.log(error);
                    Reset()
                    setSpin(false)
                    SetResultBar(<Alert key={0} variant="danger"><h5>Error Occured in Pushing Data</h5></Alert>)
                })
            setPost(false)
        }
        if (remove) {
            // console.log(url+select);
            setSpinDelete(<Spinner animation="border" variant="primary" />)
            axios.delete(url+select)
                .then(response => {
                    console.log(response);
                    Reset()
                    setReload(true)
                    setSpinDelete(false)
                })
                .catch(error=>{
                    console.log(error);
                    Reset()
                    setSpinDelete(false)
                })
                setRemove(false)
        }
        
        if (pushpic) {
            if (newPic.teamimage!=="") {
            setSpin(<Spinner animation="border" variant="warning" />)
            axios.delete("https://lime-rich-spider.cyclic.app/api/v1/Home/teampic/"+select)
                .then(response => {
                    console.log(response);
                    axios.post("https://lime-rich-spider.cyclic.app/api/v1/Home/teampic",newPic)
                    .then(response=>{
                        console.log(response);
                        Reset()
                        setReload(true)
                        setSpin(false)
                        SetResultBar(<Alert key={1} variant="success"><h5>Picture Successfully Pushed</h5></Alert>)
                    })
                    .catch(error=>{
                        console.log(error);
                        Reset()
                        setSpin(false)
                        SetResultBar(<Alert key={0} variant="danger"><h5>Error Occured in Pushing Data</h5></Alert>)

                    })
                })
                .catch(error=>{
                    console.log(error);
                    Reset()
                    setSpin(false)
                    SetResultBar(<Alert key={0} variant="danger"><h5>Error Occured in Pushing Data</h5></Alert>)
                })
            }
                
            // axios.post("https://lime-rich-spider.cyclic.app/api/v1/Home/teampic",newPic)
            //         .then(response=>{
            //             console.log(response);
            //             setReload(true)
            //         })
            //         .catch(error=>{
            //             console.log(error);
            //         })
                    

            setPushpic(false)
        }

    },[alumni,juniors,seniors,reload,post,url,data,select,remove,teampic,pushpic,newPic])

    function validate(data){
        if (data.name!==""&&data.Linkedin!==""&&data.imageURL!=="") {
            setPost(true)
        }
    }

    function Reset(){
        setData({name:"",Linkedin:"",imageURL:"",position:"",year:""})
        setNewPic({teamimage:""})
        SetResultBar(false)
        setSelect("")
    }


    return (
        <div>
            <Picmodal show={modalShow} onHide={() => setModalShow(false)} image={photoselect}></Picmodal>
            <Container>
                <img src={teampic.teamimage} style={{width: '100%', border: '0px'}} alt="group" on onDoubleClick={() => {setPhotoSelect(teampic.teamimage); setModalShow(true)}}/>
                <br/><br></br>
                {option===4&&<Button onClick={()=>{setOption(0)}} variant="danger" style={{margin:"0px"}}>Close</Button>} {option!==4&&<Button variant="info" style={{margin:"0px"}} onClick={()=>{setOption(4)}}>Change Picture</Button>}
            {option===4&&
            <div>
                <h4>Add URl of new pic</h4>
                <input type='text' value={newPic.teamimage} style={{width:"98%", height:"35px"}} onChange={e=>setNewPic({teamimage:e.target.value})}></input><br/><br/>
                <Button variant="success" style={{margin:"10px"}} onClick={()=>{
                    setSelect(teampic._id)
                    setPushpic(true)
                }}>Submit    <FontAwesomeIcon icon={faPaperPlane}/></Button> {spin}
                <br/><br/>
                {resultBar}
            </div>}
            <br/>
            <h1 align="center" >Seniors Members of Project Cell</h1>
            <Container fluid>
            <Row className="justify-content-md-center">
                {seniors.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}}/>
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            <br/>
            <Row>
            <Col xs={12} md={4}>
            <Form>
            <Form.Group controlId="exampleForm.ControlSelect1" value={select} onChange={e=>{setSelect(e.target.value);}}>
                <Form.Control as="select">
                <option key={0} value={0}>------ Select Senior------</option>
                {seniors.map((person,index)=>{
                    return(
                        <option key={index+1} value={person._id}>{person.name}</option>
                    )
                })}
                </Form.Control>
            </Form.Group>
            </Form>
            </Col>
            <Col xs={12} md={4}><Button onClick={()=>{
                setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Seniors/')
                setRemove(true)
            }}>Delete Member <FontAwesomeIcon icon={faTrashAlt}/></Button> {spinDelete}</Col> 
            <Col xs={12} md={4}>{option===1&&<Button onClick={()=>{setOption(0)}} variant="danger" style={{margin:"0px"}}>Close</Button>} {option!==1&&<Button variant="success" style={{margin:"0px"}} onClick={()=>{setOption(1)}}>Add Senior Member</Button>}</Col>
            </Row>
            {/* <Button>Delete Member</Button>  {option===1&&<Button onClick={()=>{setOption(0)}} variant="danger" style={{margin:"10px"}}>Close</Button>} {option!==1&&<Button variant="success" style={{margin:"10px"}} onClick={()=>{setOption(1)}}>Add Senior Member</Button>} */}

           {option===1&&
           <div>
                <h4>Add Member Name</h4>
                <input type='text' value={data.name} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,name: e.target.value})}></input><br/><br/>
                <h4>Add LinkedIn URL</h4>
                <input type='text' value={data.Linkedin} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,Linkedin: e.target.value})}></input><br/><br/>
                <h4>Add Image URL</h4>
                <input type='text' value={data.imageURL} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,imageURL: e.target.value})}></input><br/><br/>
                <h4>Add Position</h4>
                <input type='text' value={data.position} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,position: e.target.value})}></input><br/><br/>
                <Button variant="danger" style={{margin:"10px"}} onClick={()=>{
                    Reset()
                }}>Reset  <FontAwesomeIcon icon={faRedoAlt}/></Button>
                <Button variant="success" style={{margin:"10px"}} onClick={()=>{
                    setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Seniors')
                    validate(data)
                }}>Submit <FontAwesomeIcon icon={faPaperPlane}/></Button> {spin}
                <br/><br/>
                {resultBar}
            </div>
            }
            <br/>
            <h1 align="center" >Juniors Members of Project Cell</h1>
            <Container fluid>
            <Row className="justify-content-md-center">
                {juniors.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}}/>
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            <br/>
            <Row>
            <Col xs={12} md={4}>
            <Form>
            <Form.Group controlId="exampleForm.ControlSelect1" value={select} onChange={e=>{setSelect(e.target.value);}}>
                <Form.Control as="select">
                <option key={0} value={0}>------ Select Junior------</option>
                {juniors.map((person,index)=>{
                    return(
                        <option key={index+1} value={person._id}>{person.name}</option>
                    )
                })}
                </Form.Control>
            </Form.Group>
            </Form>
            </Col>
            <Col xs={12} md={4}><Button onClick={()=>{
                setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Juniors/')
                setRemove(true)
            }}>Delete Member <FontAwesomeIcon icon={faTrashAlt}/></Button> {spinDelete}</Col> 
            <Col xs={12} md={4}>{option===2&&<Button variant="danger" style={{marginLeft:"0px"}} onClick={()=>{setOption(0)}}>Close</Button>} {option!==2&&<Button variant="success" style={{marginLeft:"0px"}} onClick={()=>{setOption(2)}}>Add Junior Member</Button>}</Col>
            </Row>
            {option===2&&
           <div>
                <h4>Add Member Name</h4>
                <input type='text' value={data.name} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,name: e.target.value})}></input><br/><br/>
                <h4>Add LinkedIn URL</h4>
                <input type='text' value={data.Linkedin} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,Linkedin: e.target.value})}></input><br/><br/>
                <h4>Add Image URL</h4>
                <input type='text' value={data.imageURL} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,imageURL: e.target.value})}></input><br/><br/>
                <Button variant="danger" style={{margin:"10px"}} onClick={()=>{
                    Reset()
                }}>Reset  <FontAwesomeIcon icon={faRedoAlt}/></Button>
                <Button variant="success" style={{margin:"10px"}} onClick={()=>{
                    setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Juniors')
                    validate(data)
                }}>Submit <FontAwesomeIcon icon={faPaperPlane}/></Button> {spin}
                <br/><br/>
                {resultBar}
            </div>
            }
            <br/>
            <h1 align="center" >Alumni of Project Cell</h1>
            <Container fluid>
            <Row className="justify-content-md-center">
                {alumni.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}}/>
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                            {member.year&&<Card.Text>{member.year}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            <br/>
            <Row>
            <Col xs={12} md={4}>
            <Form>
            <Form.Group controlId="exampleForm.ControlSelect1" value={select} onChange={e=>{setSelect(e.target.value);}}>
                <Form.Control as="select">
                <option key={0} value={0}>------ Select Alumni------</option>
                {alumni.map((person,index)=>{
                    return(
                        <option key={index+1} value={person._id}>{person.name}</option>
                    )
                })}
                </Form.Control>
            </Form.Group>
            </Form>
            </Col>
            <Col xs={12} md={4}><Button onClick={()=>{
                setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Alumni/')
                setRemove(true)
            }}>Delete Member <FontAwesomeIcon icon={faTrashAlt}/></Button> {spinDelete}</Col> 
            <Col xs={12} md={4}>{option===3&&<Button onClick={()=>{setOption(0)}} variant="danger" style={{margin:"0px"}}>Close</Button>} {option!==3&&<Button onClick={()=>{setOption(3)}} variant="success" style={{margin:"0px"}}>Add Alumni</Button>}</Col>
            </Row>
            {/* <Button>Delete Member</Button>  {option===3&&<Button onClick={()=>{setOption(0)}} variant="danger" style={{margin:"10px"}}>Close</Button>} {option!==3&&<Button onClick={()=>{setOption(3)}} variant="success" style={{margin:"10px"}}>Add Alumni</Button>} */}
            {option===3&&
           <div>
                <h4>Add Member Name</h4>
                <input type='text' value={data.name} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,name: e.target.value})}></input><br/><br/>
                <h4>Add LinkedIn URL</h4>
                <input type='text' value={data.Linkedin} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,Linkedin: e.target.value})}></input><br/><br/>
                <h4>Add Image URL</h4>
                <input type='text' value={data.imageURL} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,imageURL: e.target.value})}></input><br/><br/>
                <h4>Add Year of Passing</h4>
                <input type='text' value={data.year} style={{width:"98%", height:"35px"}} onChange={e=>setData({...data,year: e.target.value})}></input><br/><br/>
                <Button variant="danger" style={{margin:"10px"}} onClick={()=>{
                    Reset()
                }}>Reset  <FontAwesomeIcon icon={faRedoAlt}/></Button>
                <Button variant="success" style={{margin:"10px"}} onClick={()=>{
                    setUrl('https://lime-rich-spider.cyclic.app/api/v1/Home/Alumni')
                    validate(data)
                }}>Submit <FontAwesomeIcon icon={faPaperPlane}/></Button> {spin}
                <br/><br/>
                {resultBar}
            </div>
            }
            </Container>
            <br/>
            <br/>
        </div>
    )
}

export default UpdateTeam
